import * as React from 'react';

function SvgPropertyListMixRank(props) {
  return (
    <svg width={12} height={12} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M4.106 1.979a.325.325 0 00.23.554h.69V6.15L1.894 7.958 1.55 7.36a.325.325 0 00-.595.078l-.61 2.274a.325.325 0 00.23.398l2.274.609c.28.075.51-.226.365-.476l-.345-.598 3.135-1.81 3.13 1.806-.346.599c-.145.25.086.55.365.476l2.274-.61a.325.325 0 00.23-.397l-.61-2.274a.325.325 0 00-.594-.079l-.346.599-3.132-1.81V2.534h.69c.29 0 .435-.35.23-.554L6.23.314a.325.325 0 00-.46 0L4.107 1.979z"
        fill="#fff"
      />
    </svg>
  );
}

export default SvgPropertyListMixRank;
